import Button from "@/common/components/Button";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { useNavigate, useParams } from "react-router-dom";

const DirectiveEntryExecutionEntryInProgress = () => {
  const { forwarding } = useForwardingTabContext<
    MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry
  >();

  const { id: workflowId } = useParams();
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => navigate(`/maintenance-workflows/${workflowId}/execution-entry/${forwarding.id}/execution`)}
      operationKlassToCheckPermission="Establishment::Maintenance::Directive::ExecutionEntries::Advance"
    >
      Continuar Execução
    </Button>
  );
}

export default DirectiveEntryExecutionEntryInProgress;
